import http from '@/axios/http'

const fetch = ({ url = '/get_roles' }) =>
  http
    .get(url)
    .then(response => response.data)

export default fetch
